import { render } from "./IntroduceView.vue?vue&type=template&id=56e635fe&scoped=true"
import script from "./IntroduceView.vue?vue&type=script&lang=js"
export * from "./IntroduceView.vue?vue&type=script&lang=js"

import "./IntroduceView.vue?vue&type=style&index=0&id=56e635fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e635fe"]])

export default __exports__